// removed by extract-text-webpack-plugin
module.exports = {"flexContainer":"FoodLists__flexContainer__ZVHzk"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/FoodLists/FoodLists.css
// module id = 324
// module chunks = 0